<div class="router-container" @splashTransition>
  <router-outlet class="router"></router-outlet> 
</div>